import { GetB2bEmployeesOneResponse } from '@Common/types/bo/b2b/employees';

import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const statusChoices = makeChoicesCommon<GetB2bEmployeesOneResponse['status']>()({
  current: 'resources.bo_common.b2b.employees.choices.status.current',
  past: 'resources.bo_common.b2b.employees.choices.status.past',
  retired: 'resources.bo_common.b2b.employees.choices.status.retired',
});

export const emailStateChoices = makeChoicesCommon<
  Exclude<GetB2bEmployeesOneResponse['email_state'], null>
>()({
  blocked: 'resources.bo_common.b2b.employees.choices.email_state.blocked',
  permanently_blocked: 'resources.bo_common.b2b.employees.choices.email_state.permanently_blocked',
  invalid: 'resources.bo_common.b2b.employees.choices.email_state.invalid',
});

export const emailStateTooltipChoices = makeChoicesCommon<
  Exclude<GetB2bEmployeesOneResponse['email_state'], null>
>()({
  blocked: 'resources.bo_common.b2b.employees.choices.email_state_tooltip.blocked',
  permanently_blocked:
    'resources.bo_common.b2b.employees.choices.email_state_tooltip.permanently_blocked',
  invalid: 'resources.bo_common.b2b.employees.choices.email_state_tooltip.invalid',
});

export const socialStatusChoices = makeChoicesCommon<GetB2bEmployeesOneResponse['social_status']>()(
  {
    TS: 'resources.bo_common.b2b.employees.choices.social_status.TS',
    TNS: 'resources.bo_common.b2b.employees.choices.social_status.TNS',
  },
);

export const leavingReasonChoices = makeChoicesCommon<
  Exclude<GetB2bEmployeesOneResponse['leaving_reason'], null>
>()({
  decease: 'resources.bo_common.b2b.employees.choices.leaving_reason.decease',
  job_transfer: 'resources.bo_common.b2b.employees.choices.leaving_reason.job_transfer',
  retirement: 'resources.bo_common.b2b.employees.choices.leaving_reason.retirement',
  work_ended: 'resources.bo_common.b2b.employees.choices.leaving_reason.work_ended',
  other: 'resources.bo_common.b2b.employees.choices.leaving_reason.other',
});

export const genderChoices = makeChoicesCommon()({
  male: 'resources.bo_common.b2b.employees.choices.gender.male',
  female: 'resources.bo_common.b2b.employees.choices.gender.female',
});

export const taxResidenceCodeChoices = makeChoicesCommon<
  Exclude<GetB2bEmployeesOneResponse['tax_residence_code'], null>
>()({
  tax_resident: 'resources.bo_common.b2b.employees.choices.tax_residence_code.tax_resident',
  non_tax_resident: 'resources.bo_common.b2b.employees.choices.tax_residence_code.non_tax_resident',
  resident_exempt: 'resources.bo_common.b2b.employees.choices.tax_residence_code.resident_exempt',
});

export const accountStatusChoices = makeChoicesCommon<
  GetB2bEmployeesOneResponse['account_status']
>()({
  active: 'resources.bo_common.b2b.employees.choices.account_status.active',
  closed: 'resources.bo_common.b2b.employees.choices.account_status.closed',
});

export const eckertStatusChoices = makeChoicesCommon<GetB2bEmployeesOneResponse['eckert_status']>()(
  {
    not_activated: 'resources.bo_common.b2b.employees.choices.eckert_status.not_activated',
    active: 'resources.bo_common.b2b.employees.choices.eckert_status.active',
    inactive: 'resources.bo_common.b2b.employees.choices.eckert_status.inactive',
    desherence: 'resources.bo_common.b2b.employees.choices.eckert_status.desherence',
    attente_depose_cdc:
      'resources.bo_common.b2b.employees.choices.eckert_status.attente_depose_cdc',
    depose_cdc_pee: 'resources.bo_common.b2b.employees.choices.eckert_status.depose_cdc_pee',
    depose_cdc: 'resources.bo_common.b2b.employees.choices.eckert_status.depose_cdc',
  },
);
